import axios from "axios";
import {
  destroyFile,
  generateImageFromPdf,
  getIsOwnedBySubPrincipalWarningHTML,
  getMongoFileId,
  getPictureUrlDatePath,
  getPrincipalName,
  getThirdPartySystem,
  getTokenHeader,
  getImageSize,
  aiAttributionItems
} from "@/helpers/commonHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import "./NewsEditDialog.scss";
import Login from "@/views/Login/Login.vue";
import * as newsHelper from "@/helpers/newsHelper";
import {
  getDefaultContentTypes,
  getIssueById,
  imports,
  isLocked
} from "@/helpers/newsHelper";
import * as newsGbXmlHelper from "@/helpers/newsGbXmlHelper";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import NewsImagePreview from "@/components/News/NewsImagePreview/NewsImagePreview.vue";
import NewsFilePreview from "@/components/News/NewsFilePreview/NewsFilePreview.vue";
import { uploadFile } from "@/helpers/fileHelper";
import _ from "lodash";
import { getUserById } from "@/helpers/userHelper";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import moment from "moment";
import NewsAppPushMessageEditDialog from "@/components/News/NewsAppPushMessageEditDialog/NewsAppPushMessageEditDialog.vue";
import NewsDetailViewCustomizerDialog from "@/components/News/NewsDetailViewCustomizerDialog/NewsDetailViewCustomizerDialog.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import RewriteTextDialog from "@/components/Common/RewriteTextDialog/RewriteTextDialog.vue";
import { groupBy } from "lodash/collection";
import Vue from "vue";

let newsHelperVar = { ...newsHelper };
delete newsHelperVar["imports"];

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

// prettier-ignore
// eslint-disable-next-line no-undef
const { ClassicEditor, Essentials, Paragraph, Bold, Italic, RemoveFormat, SourceEditing, FindAndReplace, UpcastWriter } = CKEDITOR;
export default {
  name: "NewsEditDialog",
  components: {
    InfoDialog,
    NewsAppPushMessageEditDialog,
    Login,
    DateInput,
    NewsImagePreview,
    NewsFilePreview,
    ValidationDialog,
    NewsDetailViewCustomizerDialog,
    LogOverview,
    RewriteTextDialog
  },
  data: () => ({
    customizeDialog: false,
    editor: ClassicEditor,
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    needLogin: false,
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    mainGray: "#7a7a7a",
    previewDialog: false,
    poiSearch: "",
    personSearch: "",
    rewriteDialog: false,
    rewriteDialogActiveTab: 0,
    rewriteDialogShowProgress: false,
    rewriteTargetKey: "content",
    rewriteCancelToken: null,
    textVariants: {
      original: "",
      seo: "",
      journalist: "",
      inviting: ""
    },

    // data()
    currentModule: "news",
    rewriteTextDialogOpen: false,
    rewriteTextDialogOriginal: "",
    rewriteTextDialogTargetKey: "content",
    prompts_api_client_url: env.prompts_api_client_url,

    password: "",
    refreshKey: 1,
    isRequired: [v => !!v || "Dieses Feld darf nicht leer sein!"],
    editedItem: {
      news_links: [{ title: "", url: "" }],
      meta_data: {
        externLinkNews: false
      },
      relatedNews: [],
      appdinx_channels: [],
      box_layout: false
    },
    issues: {},
    features: {},
    featureGroups: {},
    appContentTypes: [],
    acceptImageMimeType: `
      image/jpeg,
      image/tiff,
      image/png,
      image/gif,
      image/vnd.adobe.photoshop,
      application/x-photoshop,
      application/photoshop,
      application/psd,
      image/psd,
      application/postscript,
      application/pdf`,
    imagesDragging: false,
    filesDragging: false,
    loading: false,
    panel: 0,
    panels: [
      { title: "Nachricht Allgemein", key: 0 },
      { title: "Web Eigenschaften", key: 1 },
      { title: "HTML", key: 2 },
      { title: "Merkmale", key: 3 },
      { title: "Medien", key: 4 },
      { title: "Datum & Zeit", key: 5 },
      { title: "Push-Nachricht", key: 6 },
      { title: "Verknüpfungen & Metadaten", key: 7 },
      { title: "Bearbeitungsstatus", key: 8 }
    ],
    hidePanels: [],
    textTabs: null,
    textBlockCountByTab: {},
    contentConfigWithoutFormatting: {
      licenseKey: "GPL",
      language: "de",
      shouldNotGroupWhenFull: true,
      plugins: [
        Essentials,
        Paragraph,
        Bold,
        Italic,
        RemoveFormat,
        SourceEditing,
        FindAndReplace
      ],
      toolbar: [
        "undo",
        "redo",
        "|",
        "findAndReplace",
        "|",
        "bold",
        "italic",
        "removeFormat",
        "|"
      ],
      autoParagraph: false
    },
    debugXml: false,
    newsLoading: false,
    searchNews: "",
    creator: { first_name: "", last_name: "" },
    removeFileArray: [],
    errorList: [],
    errorDialog: false,
    createAppPushMessageDialog: false,
    existingAppPushMessage: null,
    fromExternAction: {
      importSummarizedEmail:
        "Diese Nachricht wurde durch das Zusammenfassen einer eMail durch ein LLM generiert und importiert.",
      importVerbatimEmail:
        "Diese Nachricht wurde aus dem Inhalt einer eMail durch ein LLM generiert und importiert.",
      importVerbatimAttachment:
        "Diese Nachricht wurde aus dem Inhalt eines eMail-Anhangs durch ein LLM  generiert und importiert.",
      importUnprocessedEmail:
        "Diese Nachricht wurde aus dem Inhalt einer eMail generiert und importiert."
    },
    shareWithPrincipals: [],
    shareWithAllPrincipals: false,
    shareWithPrincipalsSelectionDialog: false,
    sharedWithPrincipalsStatus: [],
    shareWithPrincipalsPanel: null,
    aiAttributionItems,
    showImageFileSizeConstraintDetails: false,
    imageFileSizeConstraintValidationRunId: 0,
    imageFileSizeBytesByUrl: {},
    imagePixelSizeByUrl: {},
    imageFileSizeConstraintValidation: {
      byKey: {},
      warnings: [],
      primaryWarning: null,
      detailRows: [],
      warningCount: 0,
      invalidChannelValues: [],
      invalidChannelTitles: [],
      hasTooSmallWarnings: false,
      hasTooLargeWarnings: false
    }
  }),
  watch: {
    isWebNews() {
      this.setPanelsForAppOrWebNews();
    },
    isAppNews() {
      this.setPanelsForAppOrWebNews();
    },
    async searchNews(word) {
      if (!word) {
        return;
      }
      const params = {
        sort: "title",
        direction: "asc",
        page: 1,
        limit: 10,
        principal_id: this.currentPrincipal?.id,
        query: word
      };
      try {
        await this.$store.dispatch("getAutocompleteNews", params);
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    "editedItem.feature_ids": function() {
      if (this.isPrintNews)
        this.editedItem.print_category_sort =
          this.getCategoryForPrintNews(this.editedItem)?.sort || 0;
    },
    "editedItem.issue_id": function(newValue) {
      this.editedItem.issue_sort =
        this.getIssueById(newValue)?.release_date || 0;
    },
    "editedItem.appdinx_duplicate_content_type_id": function() {
      this.$set(this.editedItem, "appdinx_channels", []);
      if (this.appChannels.length === 1) {
        this.$set(this.editedItem, "appdinx_channels", this.appChannelIds);
      }
    },
    rewriteDialogActiveTab(newVal) {
      this.rewriteDialogTabChange(newVal);
    },
    "editedItem.images": {
      handler(images) {
        this.updateImageFileSizeConstraintValidation();
        if (!images?.length) {
          return;
        }
        if (!this.editedItem?.contentTypes?.length) {
          return;
        }

        for (const image of images) {
          const contentTypes = this.editedItem.contentTypes.filter(
            contentType =>
              contentType.type.startsWith("images") &&
              contentType.selectedImages?.find(
                sImage => sImage.url === image.url
              )
          );
          if (!contentTypes?.length) {
            continue;
          }

          for (const contentType of contentTypes) {
            for (let i = 0; i < contentType.selectedImages.length; i++) {
              if (contentType.selectedImages[i].url === image.url) {
                this.$set(contentType.selectedImages, i, image);
              }
            }
          }
        }

        const contentTypes = this.editedItem.contentTypes.filter(contentType =>
          contentType.type.startsWith("images")
        );
        for (const contentType of contentTypes) {
          const existingImages =
            contentType.selectedImages?.filter(cImage =>
              images.find(image => image.url === cImage.url)
            ) ?? [];
          existingImages.sort((a, b) => {
            const indexA = images.findIndex(image => image.url === a.url);
            const indexB = images.findIndex(image => image.url === b.url);

            const safeIndexA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
            const safeIndexB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;

            return safeIndexA - safeIndexB;
          });
          this.$set(contentType, "selectedImages", existingImages);
          this.$set(contentType, "orderedImages", existingImages);
        }
      },
      immediate: true,
      deep: true
    },
    newsMediaChannels: {
      handler() {
        this.updateImageFileSizeConstraintValidation();
      },
      deep: true
    },
    async dialog(value) {
      if (!value) {
        return;
      }
      if (this.config.shareWithPrincipals?.length) {
        await this.getSharedWithPrincipalStatus();
      }
      this.$nextTick(async () => {
        const params = new URLSearchParams(window.location.search);
        const action = params.get("action");
        if (action === "createPushMessage") {
          window.history.replaceState(null, "", window.location.pathname);
          await this.openCreatePushMessageEditDialog();
        }
      });
    }
  },
  props: [
    "dialog",
    "config",
    "foundPois",
    "isPoiUser",
    "poiCategoryTypes",
    "isKisPersonUser",
    "persons"
  ],
  computed: {
    editedItemAiAttribution: {
      get() {
        return this.editedItem?.ai_attribution ?? "";
      },
      set(value) {
        this.$set(this.editedItem, "ai_attribution", value ?? "");
      }
    },
    showPreview() {
      return (
        !this.editedItem?.meta_data?.externLinkNews && this.newsApiKey?.length
      );
    },
    showAdditionalSortField() {
      return this.config.showAdditionalSortField;
    },
    poisByCategoryType() {
      if (!this.foundPois?.length) return null;
      return groupBy(this.foundPois, "categoryType") || [];
    },
    contentTypes() {
      if (this.editedItem?.contentTypes?.length) {
        return this.editedItem.contentTypes;
      }

      const principal = this.$store.state.principals.find(
        p => p.id === this.currentPrincipal?.id
      );

      if (principal?.newsContentTypes?.length) {
        return principal.newsContentTypes;
      }

      return getDefaultContentTypes(this.editedItem.images ?? []);
    },
    newsEditor() {
      return this.$store.state.currentUser?.scopes.includes("role:news_editor");
    },
    newsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    setNewsDefaultDate() {
      return !!this.config.setNewsDefaultDate;
    },
    channels() {
      const activeOwnChannels = this.config?.own_channels?.filter(channel =>
        this.config.channels.includes(channel.value)
      );
      const activeStandardChannels =
        this.config?.standard_channels?.filter(channel =>
          this.config.channels.includes(channel.value)
        ) ?? [];
      return activeStandardChannels.concat(activeOwnChannels).filter(Boolean);
    },
    selectedOwnChannels() {
      return this.config?.own_channels?.filter(channel =>
        this.editedItem.channels.includes(channel.value)
      );
    },
    users() {
      return this.$store.state.users;
    },
    newsMediaChannels() {
      return this.channels
        .filter(channel => channel.value !== "app")
        .map(channel => {
          const copy = Object.assign({}, channel);
          if (copy.value === "web") {
            copy.title = "Web/App";
          }
          return copy;
        });
    },
    hasImageFileSizeConstraintWarnings() {
      return !!this.imageFileSizeConstraintValidation?.warningCount;
    },
    imageFileSizeConstraintWarningCount() {
      return this.imageFileSizeConstraintValidation?.warningCount ?? 0;
    },
    imageFileSizeConstraintValidationByKey() {
      return this.imageFileSizeConstraintValidation?.byKey ?? {};
    },
    imageFileSizeConstraintInvalidChannelTitles() {
      return this.imageFileSizeConstraintValidation?.invalidChannelTitles ?? [];
    },
    imageFileSizeConstraintInvalidChannelValues() {
      return this.imageFileSizeConstraintValidation?.invalidChannelValues ?? [];
    },
    imageFileSizeConstraintWarningChannelsCount() {
      return this.imageFileSizeConstraintInvalidChannelTitles.length;
    },
    imageFileSizeConstraintWarningTitle() {
      const count = this.imageFileSizeConstraintWarningChannelsCount;
      if (!count) {
        return "";
      }
      return `Bildgröße entspricht nicht der Vorgabe für ${count} Kanal${
        count > 1 ? "e" : ""
      }.`;
    },
    imageFileSizeConstraintWarningText() {
      const channelTitles = this.imageFileSizeConstraintInvalidChannelTitles;
      if (!channelTitles.length) {
        return "";
      }

      const channelLabel =
        channelTitles.length > 1
          ? `${channelTitles.slice(0, -1).join(", ")} und ${
              channelTitles[channelTitles.length - 1]
            }`
          : channelTitles[0];

      const hasTooSmall = this.imageFileSizeConstraintValidation
        ?.hasTooSmallWarnings;
      const hasTooLarge = this.imageFileSizeConstraintValidation
        ?.hasTooLargeWarnings;
      if (hasTooSmall && hasTooLarge) {
        return `Der Kanal "${channelLabel}" erwarten andere Bildgrößen. Sie können die Nachricht trotzdem speichern und veröffentlichen.`;
      }
      if (hasTooLarge) {
        return `Der Kanal "${channelLabel}" erwarten kleinere Bilder. Sie können die Nachricht trotzdem speichern und veröffentlichen.`;
      }
      return `Der Kanal "${channelLabel}" erwarten größere Bilder. Sie können die Nachricht trotzdem speichern und veröffentlichen.`;
    },
    imageFileSizeConstraintMediaHint() {
      const warningCount = this.imageFileSizeConstraintWarningCount;
      if (!warningCount) {
        return "";
      }
      return `${warningCount} Hinweis${warningCount > 1 ? "e" : ""}`;
    },
    imageFileSizeConstraintDetailRows() {
      return this.imageFileSizeConstraintValidation?.detailRows ?? [];
    },
    hasImageFileSizeConstraintDetailRows() {
      return !!this.imageFileSizeConstraintDetailRows.length;
    },
    htmlContentEditorConfig() {
      return {
        ...this.$editorConfig,
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              styles: true,
              attributes: true,
              classes: true
            }
          ]
        }
      };
    },
    contentConfigWithFormatting() {
      return {
        ...this?.$editorConfig,
        height: 400
      };
    },
    formTitle() {
      if (this.isLocked(this.editedItem)) return "";
      return this.editedItem.isNew
        ? "Nachricht anlegen"
        : "Nachricht bearbeiten";
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    isPromptsUser() {
      if (this.isAdmin) {
        return true;
      }
      return this.$store.state.currentUser?.scopes.includes("role:prompt");
    },
    newsApiKey() {
      const defaultApiKey = this.$store.state.selectedPrincipal
        ?.modulePreviewApiKeys?.news;

      if (!defaultApiKey) {
        return this.config?.apiKeys?.[0]?.apiKey;
      }

      return defaultApiKey;
    },
    appdinxLogin() {
      return this.$store.state.selectedPrincipal?.additional_data?.appdinxLogin;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isExternNewsEditor() {
      return this.$store.state.currentUser?.scopes?.includes(
        "role:extern_news_editor"
      );
    },
    userCanSendPushMessages() {
      return this.$store.state.currentUser?.scopes.includes(
        "role:news_app_push_messages"
      );
    },
    showPushMessagePanel() {
      const pushChannels = this.channels.filter(
        channel =>
          channel.allowPushNotifications &&
          this.editedItem.channels.includes(channel.value)
      );

      if (!this.isAppNews && !pushChannels.length) {
        return false;
      }
      return this.isAdmin || this.userCanSendPushMessages;
    },
    showAppdinxWarningForPushMessages() {
      if (!this.isAppNews) {
        return false;
      }
      return !(
        this.editedItem.appdinx_article_id &&
        this.editedItem.appdinx_duplicate_content_type_id &&
        this.editedItem.appdinx_channels &&
        this.editedItem.appdinx_channels.length
      );
    },
    isEligibleNewsToCreatePushMessageFor() {
      if (this.existingAppPushMessage) {
        return false;
      }
      const pushChannels = this.channels.filter(
        channel =>
          channel.allowPushNotifications &&
          this.editedItem.channels.includes(channel.value)
      );

      if (!this.isAppNews && !pushChannels.length) {
        return false;
      }
      if (!this.editedItem._id || this.editedItem.isNew) {
        return false;
      }
      if (this.editedItem.deleted === true) {
        return false;
      }
      if (this.isAppNews && !this.editedItem.appdinx_article_id) {
        return false;
      }
      if (
        this.isAppNews &&
        !this.editedItem.appdinx_duplicate_content_type_id
      ) {
        return false;
      }
      if (this.isAppNews && !this.editedItem.appdinx_channels?.length) {
        return false;
      }
      if (this.editedItem.web_expire_date?.length) {
        const expireDate = new Date(this.editedItem.web_expire_date);
        if (expireDate < new Date()) {
          return false;
        }
      }
      return true;
    },
    isNoLongerEligibleToCreatePushMessageFor() {
      if (this.isEligibleNewsToCreatePushMessageFor) {
        return false;
      }
      if (this.editedItem.deleted) {
        return true;
      }
      if (
        this.editedItem.web_expire_date &&
        new Date(this.editedItem.web_expire_date) < new Date()
      ) {
        return true;
      }
      return false;
    },
    isPrintNews() {
      return this.editedItem?.channels?.includes("gemeindeblatt");
    },
    isWebNews() {
      const nonWebChannels = [
        "gemeindeblatt",
        "app",
        "whatsapp",
        "facebook",
        "instagram",
        "linkedin"
      ];
      const webOrOwnChannels = this.editedItem?.channels?.filter(
        channel => !nonWebChannels.includes(channel)
      );

      return !!this.editedItem?.channels?.find(channel =>
        webOrOwnChannels?.includes(channel)
      );
    },
    isAppNews() {
      return this.editedItem?.channels?.includes("app");
    },
    isExternNewsFromEmail() {
      if (!this.editedItem.fromExtern) {
        return false;
      }
      if (!this.editedItem.fromExternEmailFile) {
        return false;
      }
      const { title, url, content } = this.editedItem.fromExternEmailFile;
      return title && url && content;
    },
    isExternNewsFromWidget() {
      if (!this.editedItem.fromExtern) {
        return false;
      }
      return this.editedItem.externFormName?.length;
    },
    isExternNewsFromPrincipal() {
      if (!this.editedItem.fromExtern) {
        return false;
      }
      if (!this.editedItem.fromExternPrincipal) {
        return false;
      }
      if (
        !this.editedItem.fromExternPrincipal.principal ||
        !this.editedItem.fromExternPrincipal.originalNewsId
      ) {
        return false;
      }
      const { from, to } = this.editedItem.fromExternPrincipal.principal;
      return from.id && from.name && to.id && to.name;
    },
    isExternNewsPending() {
      if (!this.isExternNews) {
        return false;
      }
      return (
        !this.editedItem.approved &&
        !this.editedItem.declined &&
        !this.editedItem.revoked
      );
    },
    isExternNews() {
      if (!this.editedItem.fromExtern) {
        return false;
      }
      return (
        this.isExternNewsFromEmail ||
        this.isExternNewsFromWidget ||
        this.isExternNewsFromPrincipal
      );
    },
    appContentType() {
      return this.appContentTypes?.find(
        contentType =>
          contentType.appdinx_id ===
          this.editedItem.appdinx_duplicate_content_type_id
      );
    },
    appChannels() {
      if (!this.appContentType) {
        return [];
      }
      return this.features.filter(feature =>
        this.appContentType.feature_ids.includes(feature._id)
      );
    },
    appChannelIds() {
      return this.appChannels.map(channel => channel.appdinx_channel_id);
    },
    appRequestsCount() {
      if (!this.editedItem.appdinx_article_id) {
        return undefined;
      }
      return this.editedItem.appdinx_requests_count;
    },
    isPrintOverwritten() {
      return (
        this.isPrintNews &&
        this.editedItem.alternative_content?.gemeindeblatt?.length > 0
      );
    },
    isWebOverwritten() {
      return (
        (this.isWebNews || this.isAppNews) &&
        this.editedItem.alternative_content?.web?.length > 0
      );
    },
    appChannelsInvalid() {
      return (
        this.isAppNews &&
        !this.editedItem.appdinx_channels?.some(channel => !!channel)
      );
    },
    releaseAfterExpireDate() {
      if (this.editedItem.web_release_date && this.editedItem.web_expire_date)
        return (
          new Date(this.editedItem.web_release_date) >
          new Date(this.editedItem.web_expire_date)
        );
      return false;
    },
    autocompleteNews() {
      return this.$store.state.autocompleteNews;
    },
    relatedNews() {
      if (
        !this.$store.state.relatedNews?.length ||
        !this.editedItem.related_news?.length
      ) {
        return [];
      }
      return this.$store.state.relatedNews?.filter(rNews =>
        this.editedItem.related_news.includes(rNews._id)
      );
    },
    cIssues() {
      return this.issues.map(item => {
        if (item.closed) {
          if (!item.title.includes("(geschlossen)")) {
            item.title += " (geschlossen)";
          }
          item.disabled = true;
        }
        return item;
      });
    },
    cFilledFeatureGroups() {
      if (!Array.isArray(this.featureGroups)) return [];
      return this.featureGroups?.filter(item => {
        return (
          item.features.length &&
          item.channels.some(featureGroupChannel =>
            this.editedItem.channels.includes(featureGroupChannel)
          )
        );
      });
    },
    newsLinks: {
      get() {
        if (
          !Array.isArray(this.editedItem.news_links) ||
          this.editedItem.news_links.length === 0
        ) {
          this.editedItem.news_links = [{ title: "", url: "" }];
        }
        return this.editedItem.news_links;
      },
      set(value) {
        this.editedItem.news_links = value;
        this.$forceUpdate();
      }
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.$store.state.selectedPrincipal))
        .map(_ => _.typeId);
    },
    importedFrom() {
      if (!this.editedItem.additionalData?.length) {
        return;
      }

      const importedFrom = this.activeImports.filter(systemId =>
        this.editedItem.additionalData.find(d => d.typeId === systemId)
      );
      return importedFrom;
    },
    importedFromString() {
      if (!this.importedFrom?.length) {
        return;
      }

      return `${this.importedFrom
        .map(str => str.replace("-ID", ""))
        .join(", ")}-Import`;
    },
    thirdPartySystems() {
      const typeIds = this.importedFrom;
      return this.getThirdPartySystem(typeIds, "News");
    },
    isOwnedBySubPrincipal() {
      if (!this.editedItem.principal_id?.length) {
        return false;
      }
      return this.editedItem.principal_id !== this.currentPrincipal?.id;
    },
    isOwnedBySubPrincipalWarningHTML() {
      const principalName = this.getPrincipalName(this.editedItem.principal_id);
      return this.getIsOwnedBySubPrincipalWarningHTML(principalName);
    },
    logUrl() {
      return `${env.news_api_client_url}logs/${this.editedItem._id}`;
    },
    saveTargetOptions() {
      const options = [{ value: "content", text: "Standard – Beschreibung" }];
      this.editedItem?.channels?.forEach(c => {
        const found = this.channels?.find(v => v.value === c);
        if (found) {
          options.push({ value: c, text: `Kanal – ${found.title}` });
        }
      });
      return options;
    },
    textTabKeys() {
      const keys = ["general"];
      if (this.isWebNews || this.isAppNews) {
        keys.push("web");
      }
      if (this.isPrintNews) {
        keys.push("print");
      }
      this.selectedOwnChannels?.forEach(channel => {
        if (channel?.value) {
          keys.push(channel.value);
        }
      });
      return keys;
    },
    activeTextTabKey() {
      const tabIndex = isNaN(this.textTabs) ? 0 : this.textTabs;
      const tabKey = this.textTabKeys[tabIndex] || "general";
      return tabKey === "print" ? "general" : tabKey;
    },
    activeTextBlockCount() {
      return this.getTextBlockCount(this.activeTextTabKey);
    },
    showContentBlock2() {
      return this.activeTextBlockCount >= 2;
    },
    showContentBlock3() {
      return this.activeTextBlockCount >= 3;
    },
    canRemoveTextBlock2() {
      return this.showContentBlock2 && !this.showContentBlock3;
    },
    isLinkingExternWebNews() {
      if (!(this.isWebNews || this.isAppNews)) {
        return false;
      }
      const linkExternNews = this.editedItem?.meta_data?.externLinkNews;
      return !!linkExternNews;
    },
    sortedSharedWithPrincipalsStatistics() {
      return this.sharedWithPrincipalsStatus.sort((a, b) => {
        return b.title.localeCompare(a.title);
      });
    },
    sharedWithPrincipalsApprovedEntries() {
      return this.sharedWithPrincipalsStatus.filter(
        entry => entry?.approved && !entry?.declined
      );
    },
    sharedWithPrincipalsDeclinedEntries() {
      return this.sharedWithPrincipalsStatus.filter(
        entry => !entry?.approved && entry?.declined
      );
    },
    sharedWithPrincipalsPendingEntries() {
      return this.sharedWithPrincipalsStatus.filter(
        entry => !entry?.approved && !entry?.declined
      );
    },
    sharedWithPrincipalsSummary() {
      const approvedCount = this.sharedWithPrincipalsApprovedEntries.length;
      const declinedCount = this.sharedWithPrincipalsDeclinedEntries.length;
      const pendingCount = this.sharedWithPrincipalsPendingEntries.length;

      return `Gesamtes Netzwerk · ${approvedCount} übernommen · ${pendingCount} ausstehend · ${declinedCount} abgelehnt`;
    }
  },
  methods: {
    moment() {
      return moment;
    },
    ...newsHelperVar,
    ...newsGbXmlHelper,
    isLocked,
    getIssueById,
    getThirdPartySystem,
    generateImageFromPdf,
    getPrincipalName,
    getIsOwnedBySubPrincipalWarningHTML,
    getEmptyImageFileSizeConstraintValidation() {
      return {
        byKey: {},
        warnings: [],
        primaryWarning: null,
        detailRows: [],
        warningCount: 0,
        invalidChannelValues: [],
        invalidChannelTitles: [],
        hasTooSmallWarnings: false,
        hasTooLargeWarnings: false
      };
    },
    getNumberOrNull(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },
    formatPxSize(width, height) {
      const parsedWidth = this.getNumberOrNull(width);
      const parsedHeight = this.getNumberOrNull(height);
      if (parsedWidth === null || parsedHeight === null) {
        return "";
      }
      return `${parsedWidth} × ${parsedHeight} px`;
    },
    formatKbSize(kb) {
      const parsedKb = this.getNumberOrNull(kb);
      if (parsedKb === null) {
        return "";
      }
      const rounded = Number.isInteger(parsedKb)
        ? parsedKb
        : Math.round(parsedKb * 10) / 10;
      return `${String(rounded).replace(".", ",")} KB`;
    },
    extractFileSizeConstrains(channel) {
      const constraintContainer = channel?.fileSizeConstrains;
      if (!constraintContainer || typeof constraintContainer !== "object") {
        return {};
      }
      if (constraintContainer.fileSizeConstrains) {
        return constraintContainer.fileSizeConstrains;
      }
      if (constraintContainer.imagesSizeConstrains) {
        return constraintContainer.imagesSizeConstrains;
      }
      if (constraintContainer.images) {
        return constraintContainer.images;
      }
      if (
        "active" in constraintContainer ||
        "unit" in constraintContainer ||
        "px" in constraintContainer ||
        "kb" in constraintContainer
      ) {
        return constraintContainer;
      }
      return {};
    },
    normalizeFileSizeConstrains(channel) {
      const rawConstrains = this.extractFileSizeConstrains(channel);
      const units = Array.isArray(rawConstrains?.unit)
        ? rawConstrains.unit
        : typeof rawConstrains?.unit === "string"
        ? [rawConstrains.unit]
        : [];
      return {
        active: !!rawConstrains?.active,
        unit: units.filter(unit => ["px", "kb"].includes(unit)),
        px: rawConstrains?.px ?? {},
        kb: rawConstrains?.kb ?? {}
      };
    },
    getImageUrl(file) {
      return file?.url ?? file?.originalUrl ?? "";
    },
    getImageConstraintName(file, index) {
      const nameFromUrl = this.getImageUrl(file)
        ?.split("?")[0]
        ?.split("#")[0]
        ?.split("/")
        ?.pop();
      const candidates = [
        file?.original_name,
        file?.newFile?.name,
        file?.title,
        nameFromUrl
      ];
      const resolvedName = candidates.find(
        candidate => typeof candidate === "string" && candidate.trim().length
      );
      if (resolvedName) {
        return resolvedName.trim();
      }
      return `Bild ${index + 1}`;
    },
    async getImagePixelSize(file) {
      const imageUrl = this.getImageUrl(file);
      if (!imageUrl?.length) {
        return null;
      }
      if (this.imagePixelSizeByUrl[imageUrl]) {
        return this.imagePixelSizeByUrl[imageUrl];
      }
      try {
        const size = await getImageSize(imageUrl);
        if (size) {
          this.imagePixelSizeByUrl[imageUrl] = size;
        }
        return size ?? null;
      } catch (error) {
        return null;
      }
    },
    getFileSizeBytesFromDataUrl(file) {
      const dataUrl = file?.originalUrl;
      if (!dataUrl?.startsWith("data:")) {
        return null;
      }
      const base64 = dataUrl.split(",")[1];
      if (!base64?.length) {
        return null;
      }
      const padding = (base64.match(/=*$/)?.[0] ?? "").length;
      return Math.max(Math.floor((base64.length * 3) / 4) - padding, 0);
    },
    getKnownFileSizeBytes(file, fallbackSize = null) {
      const candidates = [
        file?.size,
        file?.file_size,
        file?.fileSize,
        file?.filesize,
        file?.bytes,
        file?.newFile?.size,
        fallbackSize
      ];
      for (const candidate of candidates) {
        const parsed = this.getNumberOrNull(candidate);
        if (parsed !== null && parsed > 0) {
          return parsed;
        }
      }
      return null;
    },
    async fetchImageFileSizeBytes(imageUrl) {
      if (!imageUrl || imageUrl.startsWith("data:")) {
        return null;
      }
      if (this.imageFileSizeBytesByUrl[imageUrl]) {
        return this.imageFileSizeBytesByUrl[imageUrl];
      }

      try {
        const headResponse = await fetch(imageUrl, { method: "HEAD" });
        const contentLength = this.getNumberOrNull(
          headResponse?.headers?.get("content-length")
        );
        if (contentLength !== null && contentLength > 0) {
          this.imageFileSizeBytesByUrl[imageUrl] = contentLength;
          return contentLength;
        }
      } catch (error) {
        // Fallback to GET.
      }

      try {
        const response = await fetch(imageUrl);
        if (!response?.ok) {
          return null;
        }
        const blob = await response.blob();
        const bytes = this.getNumberOrNull(blob?.size);
        if (bytes !== null && bytes > 0) {
          this.imageFileSizeBytesByUrl[imageUrl] = bytes;
          return bytes;
        }
      } catch (error) {
        return null;
      }

      return null;
    },
    async getImageFileSizeBytes(file) {
      const fallbackSize = this.getFileSizeBytesFromDataUrl(file);
      const knownFileSize = this.getKnownFileSizeBytes(file, fallbackSize);
      if (knownFileSize !== null) {
        return knownFileSize;
      }
      const imageUrl = this.getImageUrl(file);
      return this.fetchImageFileSizeBytes(imageUrl);
    },
    getExpectedPxText(pxConstraints, reasons) {
      const minWidth = this.getNumberOrNull(pxConstraints?.min?.width);
      const minHeight = this.getNumberOrNull(pxConstraints?.min?.height);
      const maxWidth = this.getNumberOrNull(pxConstraints?.max?.width);
      const maxHeight = this.getNumberOrNull(pxConstraints?.max?.height);
      const hasMin = minWidth !== null && minHeight !== null;
      const hasMax = maxWidth !== null && maxHeight !== null;
      const needsMin = reasons.includes("px-min");
      const needsMax = reasons.includes("px-max");

      if (needsMin && needsMax && hasMin && hasMax) {
        return `${this.formatPxSize(
          minWidth,
          minHeight
        )} bis ${this.formatPxSize(maxWidth, maxHeight)}`;
      }
      if (needsMin && hasMin) {
        return `ab ${this.formatPxSize(minWidth, minHeight)}`;
      }
      if (needsMax && hasMax) {
        return `bis ${this.formatPxSize(maxWidth, maxHeight)}`;
      }
      return "";
    },
    getExpectedKbText(kbConstraints, reasons) {
      const minKb = this.getNumberOrNull(kbConstraints?.min);
      const maxKb = this.getNumberOrNull(kbConstraints?.max);
      const hasMin = minKb !== null;
      const hasMax = maxKb !== null;
      const hasKbReason = reasons.some(reason => reason.startsWith("kb"));

      if (!hasKbReason) {
        return "";
      }
      if (hasMin && hasMax) {
        return `von ${this.formatKbSize(minKb)} bis ${this.formatKbSize(
          maxKb
        )}`;
      }
      if (hasMin) {
        return `von ${this.formatKbSize(minKb)}`;
      }
      if (hasMax) {
        return `bis ${this.formatKbSize(maxKb)}`;
      }
      return "";
    },
    getExpectedConstraintText(constrains, reasons) {
      const parts = [];
      if (
        constrains.unit.includes("px") &&
        reasons.some(reason => reason.startsWith("px"))
      ) {
        const pxText = this.getExpectedPxText(constrains.px, reasons);
        if (pxText) {
          parts.push(pxText);
        }
      }
      if (
        constrains.unit.includes("kb") &&
        reasons.some(reason => reason.startsWith("kb"))
      ) {
        const kbText = this.getExpectedKbText(constrains.kb, reasons);
        if (kbText) {
          parts.push(kbText);
        }
      }
      return parts.join(" · ");
    },
    getOriginalConstraintText({ imageSize, fileSizeKb, constrains, reasons }) {
      const parts = [];
      if (
        constrains.unit.includes("px") &&
        imageSize &&
        reasons.some(reason => reason.startsWith("px"))
      ) {
        const imageText = this.formatPxSize(imageSize.width, imageSize.height);
        if (imageText) {
          parts.push(imageText);
        }
      }
      if (
        constrains.unit.includes("kb") &&
        fileSizeKb !== null &&
        reasons.some(reason => reason.startsWith("kb"))
      ) {
        const kbText = this.formatKbSize(fileSizeKb);
        if (kbText) {
          parts.push(kbText);
        }
      }
      return parts.join(" · ");
    },
    getConstraintStatus(reasons) {
      const tooSmall = reasons.some(reason =>
        ["px-min", "kb-min"].includes(reason)
      );
      const tooLarge = reasons.some(reason =>
        ["px-max", "kb-max"].includes(reason)
      );
      return {
        tooSmall,
        tooLarge,
        label:
          tooSmall && !tooLarge
            ? "Zu klein"
            : !tooSmall && tooLarge
            ? "Zu groß"
            : "Ungültig"
      };
    },
    async evaluateImageFileSizeConstraints(file, index) {
      const key =
        file?.id || file?._id || file?.url || file?.originalUrl || index;
      const imageName = this.getImageConstraintName(file, index);
      const selectedChannels = Array.isArray(file?.channels)
        ? file.channels.filter(Boolean)
        : [];
      if (!selectedChannels.length) {
        return {
          key,
          imageName,
          hasIssue: false,
          tooSmall: false,
          tooLarge: false,
          invalidChannelValues: [],
          invalidChannelTitles: [],
          invalidChannels: [],
          imageSize: null,
          fileSizeKbText: null
        };
      }

      const imageSize = await this.getImagePixelSize(file);
      const fileSizeBytes = await this.getImageFileSizeBytes(file);
      const fileSizeKb =
        fileSizeBytes === null ? null : Number(fileSizeBytes / 1024);

      const invalidChannels = [];
      let tooSmall = false;
      let tooLarge = false;

      for (const channelValue of selectedChannels) {
        const channel = this.newsMediaChannels?.find(
          item => item.value === channelValue
        );
        if (!channel) {
          continue;
        }

        const constrains = this.normalizeFileSizeConstrains(channel);
        if (!constrains.active || !constrains.unit.length) {
          continue;
        }

        const reasons = [];
        if (constrains.unit.includes("px") && imageSize) {
          const minWidth = this.getNumberOrNull(constrains.px?.min?.width);
          const minHeight = this.getNumberOrNull(constrains.px?.min?.height);
          const maxWidth = this.getNumberOrNull(constrains.px?.max?.width);
          const maxHeight = this.getNumberOrNull(constrains.px?.max?.height);

          if (
            minWidth !== null &&
            minHeight !== null &&
            (imageSize.width < minWidth || imageSize.height < minHeight)
          ) {
            reasons.push("px-min");
          }
          if (
            maxWidth !== null &&
            maxHeight !== null &&
            (imageSize.width > maxWidth || imageSize.height > maxHeight)
          ) {
            reasons.push("px-max");
          }
        }

        if (constrains.unit.includes("kb") && fileSizeKb !== null) {
          const minKb = this.getNumberOrNull(constrains.kb?.min);
          const maxKb = this.getNumberOrNull(constrains.kb?.max);
          if (minKb !== null && fileSizeKb < minKb) {
            reasons.push("kb-min");
          }
          if (maxKb !== null && fileSizeKb > maxKb) {
            reasons.push("kb-max");
          }
        }

        if (!reasons.length) {
          continue;
        }

        const status = this.getConstraintStatus(reasons);
        tooSmall = tooSmall || status.tooSmall;
        tooLarge = tooLarge || status.tooLarge;
        invalidChannels.push({
          value: channel.value,
          title: channel.title || channel.value,
          expectedText: this.getExpectedConstraintText(constrains, reasons),
          originalText: this.getOriginalConstraintText({
            imageSize,
            fileSizeKb,
            constrains,
            reasons
          }),
          reasons
        });
      }

      const invalidChannelValues = invalidChannels.map(
        channel => channel.value
      );
      const invalidChannelTitles = invalidChannels.map(
        channel => channel.title
      );
      const statusLabel = this.getConstraintStatus(
        invalidChannels.flatMap(channel => channel.reasons)
      ).label;

      return {
        key,
        imageName,
        hasIssue: invalidChannels.length > 0,
        tooSmall,
        tooLarge,
        statusLabel,
        invalidChannelValues,
        invalidChannelTitles,
        invalidChannels,
        imageSize,
        fileSizeKbText:
          fileSizeKb === null ? null : this.formatKbSize(fileSizeKb)
      };
    },
    async updateImageFileSizeConstraintValidation() {
      const files = Array.isArray(this.editedItem?.images)
        ? this.editedItem.images
        : [];
      const runId = ++this.imageFileSizeConstraintValidationRunId;

      if (!files.length) {
        this.imageFileSizeConstraintValidation = this.getEmptyImageFileSizeConstraintValidation();
        this.showImageFileSizeConstraintDetails = false;
        return;
      }

      const validations = await Promise.all(
        files.map((file, index) =>
          this.evaluateImageFileSizeConstraints(file, index)
        )
      );

      if (runId !== this.imageFileSizeConstraintValidationRunId) {
        return;
      }

      const byKey = validations.reduce((accumulator, validation) => {
        accumulator[validation.key] = validation;
        return accumulator;
      }, {});
      const warnings = validations.filter(validation => validation.hasIssue);
      const invalidChannels = warnings.flatMap(
        warning => warning.invalidChannels ?? []
      );
      const invalidChannelValues = [
        ...new Set(
          invalidChannels.map(channel => channel.value).filter(Boolean)
        )
      ];
      const invalidChannelTitles = [
        ...new Set(
          invalidChannels.map(channel => channel.title).filter(Boolean)
        )
      ];
      const primaryWarning = warnings[0] ?? null;
      const detailRows = warnings.flatMap(warning =>
        (warning.invalidChannels ?? []).map((channel, index) => ({
          rowKey: `${warning.key}-${channel?.value || channel?.title || index}`,
          channelValue: channel.value,
          channelTitle: channel.title,
          statusLabel: this.getConstraintStatus(channel?.reasons ?? []).label,
          expectedText: channel.expectedText,
          imageName: warning.imageName,
          actualText: channel.originalText
        }))
      );

      this.imageFileSizeConstraintValidation = {
        byKey,
        warnings,
        primaryWarning,
        detailRows,
        warningCount: warnings.length,
        invalidChannelValues,
        invalidChannelTitles,
        hasTooSmallWarnings: warnings.some(warning => warning.tooSmall),
        hasTooLargeWarnings: warnings.some(warning => warning.tooLarge)
      };
      if (!warnings.length) {
        this.showImageFileSizeConstraintDetails = false;
      }
    },
    channelHasFileSizeConstraintWarning(channelValue) {
      return this.imageFileSizeConstraintInvalidChannelValues.includes(
        channelValue
      );
    },
    openMediaPanelForImageFileSizeWarnings() {
      this.openPanel(4);
      this.$nextTick(() => {
        const element = document.querySelector(".news_images__wrapper");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    toggleImageFileSizeConstraintDetails() {
      this.showImageFileSizeConstraintDetails = !this
        .showImageFileSizeConstraintDetails;
    },
    triggerDialog({ save, contentTypes, close }) {
      if (save && contentTypes?.length) {
        this.editedItem.contentTypes = contentTypes;
      }

      if (close) {
        this.customizeDialog = !this.customizeDialog;
        this.refreshKey++;
      }
    },

    onEditorReady(editor, isDefaultContent) {
      if (isDefaultContent) {
        if (this.config.defaultContentAllowTextFormatting) {
          return;
        }
      }
      // custom paste handler see: https://ckeditor.com/docs/ckeditor5/latest/framework/deep-dive/clipboard.html

      const writer = new UpcastWriter(editor.editing.view.document);

      function processChildren(children) {
        const result = [];

        for (const child of children) {
          // if child is a paragraph, get all children of the paragraph to add them without paragraph but with br - needed to keep xml clean
          if (child.is?.("element", "p")) {
            result.push(...processChildren(Array.from(child.getChildren())));
            result.push(writer.createElement("br"));
            continue;
          }

          if (child.is?.("element")) {
            const attributes = Object.fromEntries(child.getAttributes());
            const nestedChildren = processChildren(
              Array.from(child.getChildren())
            );
            result.push(
              writer.createElement(child.name, attributes, nestedChildren)
            );
            continue;
          }

          result.push(child);
        }

        // remove last br if it is the only child
        if (result.length && result[result.length - 1].name === "br") {
          result.pop();
        }

        return result;
      }

      editor.plugins
        .get("ClipboardPipeline")
        .on("inputTransformation", (evt, data) => {
          if (data.method !== "paste") return;

          const fragmentChildren = Array.from(data.content.getChildren());
          const newChildren = processChildren(fragmentChildren);

          data.content = writer.createDocumentFragment(newChildren);
        });

      editor.editing.view.document.on("enter", (evt, data) => {
        const selection = editor.model.document.selection;
        const isInList =
          selection.hasAttribute("listType") ||
          !!selection.getFirstPosition()?.parent?.getAttribute?.("listType");

        if (isInList) {
          return;
        }

        editor.execute("shiftEnter");
        evt.stop();
        data.preventDefault();
      });
    },
    cleanupContentTypes(contentTypes) {
      return contentTypes.map(contentType => {
        const { selectedImages, ...rest } = contentType;

        if (!selectedImages?.length && !contentType.type.includes("images")) {
          return rest;
        }

        let availableImages = selectedImages?.filter(sImage =>
          this.editedItem.images.find(i => i.url === sImage.url)
        );

        if (this.editedItem._id && !this.editedItem.isNew) {
          console.info(
            "already created, do not need to assign fallback images"
          );
          return {
            selectedImages,
            ...rest
          };
        }

        if (availableImages?.length) {
          return {
            selectedImages: availableImages,
            ...rest
          };
        }

        // if no images are available, return empty array, only for images2, 3 and 4
        if (
          !selectedImages?.length &&
          ["images2", "images3", "images4"].includes(contentType.type)
        ) {
          return {
            selectedImages: [],
            ...rest
          };
        }

        let fallbackImages = this.editedItem.images ?? [];

        rest.selectedImages = fallbackImages;
        rest.orderedImages = fallbackImages;
        return rest;
      });
    },
    panelDisplay(key) {
      return this.hidePanels.includes(key) ? "d-none" : "";
    },
    openPanel(key) {
      this.panel = key;
    },
    getUserName(user) {
      const foundUser = this.users.find(item => item._id === user);
      return `${foundUser.first_name} ${foundUser.last_name}`;
    },
    getChannelTitle(value) {
      if (value) {
        return this.channels?.find(channel => channel.value.includes(value))
          ?.title;
      }
      return value;
    },
    addNewsLink() {
      this.newsLinks.push({ title: "", url: "" });
    },
    removeNewsLink(index) {
      const remove = this.newsLinks;
      remove.splice(index, 1);
      this.newsLinks = remove;
    },
    move(array, element, delta) {
      let index = array.indexOf(element); //find element to move
      let newIndex = index + delta; //calculate destination-index
      if (newIndex < 0 || newIndex === array.length) return; //Already at the top or bottom.
      let indexes = [index, newIndex].sort(); //Sort the indexes
      const moveNewsLinks = this.newsLinks;
      moveNewsLinks.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
      this.newsLinks = moveNewsLinks;
    },
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async triggerPreview() {
      const confirmRes = await this.$confirm(
        `Möchten Sie Änderungen speichern?`,
        confirmWarningConfig
      );
      if (confirmRes) {
        await this.save(false);
        this.previewDialog = true;
        // reload iframe to refresh news preview, 1 sec delay needed
        const foundElement = document.getElementById("news_dv_iframe");
        if (foundElement) document.getElementById("news_dv_iframe").src += "";
      }
    },
    fillData(data) {
      this.editedItem = data.editedItem;
      this.showImageFileSizeConstraintDetails = false;
      this.imageFileSizeConstraintValidation = this.getEmptyImageFileSizeConstraintValidation();
      if (!this.editedItem.channels) {
        this.editedItem.channels = [];
      }
      this.issues = data.issues;
      this.features = data.features;
      this.featureGroups = data.featureGroups;
      this.appContentTypes = data.appContentTypes;
      this.createMissingProperties();
      this.initializeTextBlockCount();
      // file + imagepreview uses id before upload and _id after upload
      this.editedItem.images = this?.editedItem?.images?.map(file => {
        file.id = file._id;
        return file;
      });
      this.editedItem.files = this?.editedItem?.files?.map(file => {
        file.id = file._id;
        return file;
      });

      if (this.editedItem.related_news.length > 0) {
        this.refreshRelatedNews();
      }
      if (this.editedItem.creator_id) {
        getUserById(this.editedItem.creator_id).then(creator => {
          this.creator = creator;
        });
      }
      if (this.setNewsDefaultDate && !this.editedItem._id)
        this.editedItem.newsDate = new Date().toISOString();
      if (this.config.expireInDays)
        this.editedItem.web_expire_date = moment(new Date())
          .add(this.config.expireInDays, "days")
          .toISOString();
      this.unsaved = JSON.stringify(this.editedItem, null, 2);
    },
    loadingStatus(status) {
      this.loading = status;
    },
    close() {
      if (!this.editedItem._id && !this.editedItem.isNew) {
        this.$emit("close");
        return;
      }
      this.$confirm(
        `Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!`,
        confirmWarningConfig
      ).then(res => {
        if (res) {
          this.logs = [];
          this.viewLog = [];
          this.$store.state.relatedNews = null;
          this.$emit("close");
        }
      });
    },
    getParamsForIframeSrc(colorObj) {
      let c = "?";
      const paramsObj = {
        apiKey: this.newsApiKey,
        ...colorObj
      };
      let params = "";
      for (const [key, value] of Object.entries(paramsObj)) {
        params += `${c}${key}=${encodeURIComponent(value)}`;
        c = "&";
      }
      return params;
    },
    getIframeSrc() {
      const slug = this.editedItem.meta_data.url_part || this.editedItem._id;
      return `${
        env.news_widget_api_url
      }news/detail/${slug}${this.getParamsForIframeSrc(
        this.newsApiKey?.color
      )}`;
    },
    getIframeHTML() {
      return `<iframe id="news_dv_iframe" style="width: 100%; height: 100vh" src="${this.getIframeSrc()}"></iframe>`;
    },
    setPanelsForAppOrWebNews() {
      const hiddenPanels = [];
      if (!this.isAppNews && !this.isWebNews) {
        hiddenPanels.push(5);
        hiddenPanels.push(2);
      }

      if (!this.isWebNews) {
        hiddenPanels.push(1);
      }

      if (!this.showPushMessagePanel) {
        hiddenPanels.push(6);
      }

      if (!this.isAdmin) {
        hiddenPanels.push(2);
      }

      this.hidePanels = [...hiddenPanels];

      if (this.hidePanels.includes(this.panel)) {
        this.panel = undefined;
      }
    },
    // All panels must be open to validate the form. Small delay needed for it to be effective.
    async openAllPanelsForValidation() {
      return new Promise(resolve => {
        const panels = this.panels
          .filter(panel => !this.hidePanels.includes(panel.key))
          .map(panel => panel.key);
        this.panel = panels;
        setTimeout(resolve, 1);
      });
    },
    debounceSave: _.debounce(async function(close) {
      await this.save(close);
    }, 500),
    async save(close) {
      const panel = this.panel;
      await this.openAllPanelsForValidation();
      const isValid = this.$refs.editForm.validate();
      this.panel = panel;
      if (!isValid) {
        this.errorList = [];
        const form = this.$refs.editForm;
        const invalidFields = form._data.inputs.filter(i => !i.valid);
        this.errorList = [];
        invalidFields.forEach(field => {
          this.errorList.push({
            field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
              "*",
              ""
            ),
            validations: field.validations
          });
        });
        if (this.errorList.length) {
          this.errorDialog = true;
        }
        this.loadingStatus(false);
        return;
      }

      let success = false;
      this.loadingStatus(true);
      try {
        await this.saveImages();
        await this.saveFiles();

        try {
          await this.removeFiles();
        } catch (error) {
          console.error(error);
        }

        if (this.editedItem?.contentTypes?.length) {
          this.editedItem.contentTypes = this.cleanupContentTypes(
            this.editedItem.contentTypes
          );
        }
        if (!this.editedItem?.contentTypes?.length) {
          const contentTypes = this.contentTypes?.length
            ? this.contentTypes
            : getDefaultContentTypes(this.editedItem.images ?? []);
          this.editedItem.contentTypes = contentTypes;
        }

        success = this.editedItem.isNew
          ? await this.createNews()
          : await this.updateNews();
        if (success) {
          this.unsaved = JSON.stringify(this.editedItem, null, 2);
          if (close) this.$store.state.relatedNews = null;
          this.$emit("afterSave", close);
        }
      } catch (ex) {
        //catch invalid token. open login-dialog
        if (ex.toString().includes("401")) {
          this.needLogin = true;
          this.loadingStatus(false);
          return;
        }
        if (ex.response?.data?.toString().includes("issue_deadline_fail")) {
          this.createError({
            ...ex,
            text:
              "Ausgabe bereits geschlossen!\nBitte wählen sie eine andere Ausgabe.\n"
          });
          await this.loadIssues();
          this.loadingStatus(false);
          return;
        }

        this.createError(ex);
      }
      this.loadingStatus(false);
      return success;
    },
    async openCreatePushMessageEditDialog() {
      if (this.existingAppPushMessage) {
        this.createAppPushMessageDialog = true;
        return;
      }

      const saveConfirm = await this.$confirm(
        "Zum Anlegen einer Push-Nachricht muss die Nachricht gespeichert werden.<br/><br/>Nachricht speichern und fortfahren?",
        {
          buttonFalseText: "Abbrechen",
          buttonTrueText: "Speichern"
        }
      );
      if (!saveConfirm) {
        return;
      }

      try {
        const saveSuccess = await this.save(false);
        if (!saveSuccess) {
          return;
        }
      } catch (e) {
        return;
      }

      if (!this.isEligibleNewsToCreatePushMessageFor) {
        await this.createError({
          text:
            "Die Nachricht erfüllt nicht (mehr) die Bedingungen zum Anlegen einer Push-Nachricht. Bitte überprüfen Sie Ihre Eingaben."
        });
        return;
      }

      this.createAppPushMessageDialog = true;
    },
    afterCreateAppPushMessage(data) {
      this.createAppPushMessageDialog = false;
      if (!(data instanceof Event)) {
        this.existingAppPushMessage = data;
      }
    },
    getCleanedUpLockedNews() {
      const {
        _id,
        relatedNews,
        additionalData,
        channels,
        alternative_content,
        meta_data,
        newsDate,
        news_links,
        principal_id,
        related_news,
        web_release_date,
        web_expire_date,
        contentTypes
      } = this.editedItem;

      return {
        _id,
        relatedNews,
        additionalData,
        channels,
        alternative_content,
        related_news,
        meta_data,
        newsDate,
        news_links,
        principal_id,
        web_expire_date,
        web_release_date,
        contentTypes,
        onlyUpdateWebData: true
      };
    },

    async updateNews() {
      delete this.editedItem.create_date;
      let item = this.editedItem;
      if (this.isLocked(this.editedItem)) {
        item = this.getCleanedUpLockedNews();
        if (!item.channels?.includes("gemeindeblatt"))
          item.channels.push("gemeindeblatt");
      }
      const headers = getTokenHeader(),
        res = await axios.put(`${env.news_api_client_url}news`, item, {
          headers
        });
      this.editedItem = res.data;
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      this.editedItem.appdinx_article_id = res.data?.appdinx_article_id;
      return res.status === 200;
    },
    async newsPut(data) {
      if (this.editedItem.isNew) {
        this.createError({
          text: "Nachricht muss angelegt sein."
        });
        return;
      }
      const headers = getTokenHeader(),
        res = await axios.put(`${env.news_api_client_url}news`, data, {
          headers
        });
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      return res.status === 200;
    },
    async saveWebDates() {
      return await this.newsPut(
        // webservice only keeps _id,principal_id,web_release_date,web_expire_date and web_archive_date
        { ...this.editedItem, onlyUpdateWebDates: true }
      );
    },
    async saveMetaInfos() {
      return await this.newsPut(
        // webservice only keeps _id,principal_id,related_news and meta_data
        { ...this.editedItem, onlyUpdateMetaInfos: true }
      );
    },
    async createNews() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}news`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      this.editedItem.meta_data.url_part = res.data?.meta_data?.url_part;
      this.editedItem.web_expire_date = res.data?.web_expire_date;
      this.editedItem.appdinx_article_id = res.data?.appdinx_article_id;
      return res.status === 200;
    },
    createMissingProperties() {
      if (typeof this.editedItem.content_2 !== "string") {
        this.editedItem.content_2 = "";
      }
      if (typeof this.editedItem.content_3 !== "string") {
        this.editedItem.content_3 = "";
      }
      if (!this.editedItem.alternative_content) {
        this.editedItem.alternative_content = {
          web: "",
          gemeindeblatt: ""
        };
      }
      if (!this.editedItem.alternative_content_2) {
        this.editedItem.alternative_content_2 = {
          web: ""
        };
      }
      if (!this.editedItem.alternative_content_3) {
        this.editedItem.alternative_content_3 = {
          web: ""
        };
      }
    },
    initializeTextBlockCount() {
      const textBlockCountByTab = {};
      this.getEditableTextTabKeys().forEach(tabKey => {
        if (this.hasAnyTextBlockContent(3, tabKey)) {
          textBlockCountByTab[tabKey] = 3;
        } else if (this.hasAnyTextBlockContent(2, tabKey)) {
          textBlockCountByTab[tabKey] = 2;
        } else {
          textBlockCountByTab[tabKey] = 1;
        }
      });
      this.textBlockCountByTab = textBlockCountByTab;
    },
    getEditableTextTabKeys() {
      return this.textTabKeys.filter(tabKey => tabKey !== "print");
    },
    getTextBlockCount(tabKey = "general") {
      return this.textBlockCountByTab?.[tabKey] || 1;
    },
    setTextBlockCount(tabKey = "general", count = 1) {
      this.$set(
        this.textBlockCountByTab,
        tabKey,
        Math.max(1, Math.min(3, count))
      );
    },
    hasAnyTextBlockContent(level, tabKey = "general") {
      const contentKey = `content_${level}`;
      const alternativeKey = `alternative_content_${level}`;
      if (tabKey === "general") {
        const defaultText = this.editedItem?.[contentKey];
        return defaultText?.length;
      }

      const alternatives = this.editedItem?.[alternativeKey];
      const alternativeText = alternatives?.[tabKey];
      return alternativeText?.length;
    },
    addTextBlock(level, tabKey) {
      tabKey = tabKey || this.activeTextTabKey;
      const currentCount = this.getTextBlockCount(tabKey);
      if (level === 2) {
        this.setTextBlockCount(tabKey, Math.max(currentCount, 2));
        return;
      }

      if (level === 3 && currentCount >= 2) {
        this.setTextBlockCount(tabKey, 3);
      }
    },
    removeTextBlock(level, tabKey) {
      tabKey = tabKey || this.activeTextTabKey;
      if (level === 2 && this.getTextBlockCount(tabKey) >= 3) {
        return;
      }

      if (level === 3) {
        this.clearTextBlock(3, tabKey);
        this.setTextBlockCount(tabKey, 2);
        return;
      }

      if (level === 2) {
        this.clearTextBlock(2, tabKey);
        this.clearTextBlock(3, tabKey);
        this.setTextBlockCount(tabKey, 1);
      }
    },
    clearTextBlock(level, tabKey = "general") {
      const contentKey = `content_${level}`;
      const alternativeKey = `alternative_content_${level}`;

      if (tabKey === "general") {
        this.$set(this.editedItem, contentKey, "");
        return;
      }

      if (!this.editedItem[alternativeKey]) {
        this.$set(this.editedItem, alternativeKey, { web: "" });
      }

      this.$set(this.editedItem[alternativeKey], tabKey, "");
    },
    editCustomization() {
      this.customizeDialog = true;
      this.refreshKey++;
    },
    async debugGbXml() {
      if (this.debugXml) {
        if (!this?.editedItem?.issue_id) {
          console.info("debugGbXml: keine ausgabe gewählt!");
          return;
        }
        await this.loadIssues();
        await this.loadFeatures();
        await this.loadFeatureGroups();

        let xml = await this.buildIssueXml([this.editedItem]);
        console.info("xml", xml);
      }
    },
    getImagesWithChannel(channelValue) {
      if (!channelValue || !Array.isArray(this.editedItem?.images)) {
        return [];
      }
      return this.editedItem.images.filter(image => {
        return (
          Array.isArray(image?.channels) &&
          image.channels.includes(channelValue)
        );
      });
    },
    getImagesWithoutChannel(channelValue) {
      if (!channelValue || !Array.isArray(this.editedItem?.images)) {
        return [];
      }
      return this.editedItem.images.filter(image => {
        return (
          Array.isArray(image?.channels) &&
          !image.channels.includes(channelValue)
        );
      });
    },
    removeChannelFromImages(channelValue) {
      this.getImagesWithChannel(channelValue).forEach(image => {
        if (
          !Array.isArray(image?.channels) ||
          !image.channels.includes(channelValue)
        ) {
          return;
        }
        image.channels = image.channels.filter(channel => {
          return channel?.length && channel !== channelValue;
        });
        image.channels.reverse().reverse();
      });
    },
    addChannelToImages(channelValue) {
      this.getImagesWithoutChannel(channelValue).forEach(image => {
        if (!Array.isArray(image.channels)) {
          image.channels = [];
        }
        image.channels.push(channelValue);
      });
    },
    //remove or add publication-channel
    async toggleChannel(channelValue) {
      if (this.editedItem.channels.includes(channelValue)) {
        this.editedItem.channels = this.editedItem.channels.filter(item => {
          return item?.length && item !== channelValue;
        });
        this.removeChannelFromImages(channelValue);
        this.editedItem.channels.reverse().reverse();
        this.$delete(this.textBlockCountByTab, channelValue);
      } else {
        this.editedItem.channels.push(channelValue);
        this.addChannelToImages(channelValue);
      }

      if (!this.editedItem.alternative_content_2)
        this.editedItem.alternative_content_2 = { web: "" };
      if (!this.editedItem.alternative_content_2[channelValue])
        this.editedItem.alternative_content_2[channelValue] = "";
      if (!this.editedItem.alternative_content_3)
        this.editedItem.alternative_content_3 = { web: "" };
      if (!this.editedItem.alternative_content_3[channelValue])
        this.editedItem.alternative_content_3[channelValue] = "";

      if (!this.textBlockCountByTab[channelValue]) {
        if (this.hasAnyTextBlockContent(3, channelValue)) {
          this.setTextBlockCount(channelValue, 3);
        } else if (this.hasAnyTextBlockContent(2, channelValue)) {
          this.setTextBlockCount(channelValue, 2);
        } else {
          this.setTextBlockCount(channelValue, 1);
        }
      }
    },
    async addDropImage(e) {
      if (!Array.isArray(this.editedItem.images)) this.editedItem.images = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const fileData = await this.readFileUrl(file);
        file.channels = this.channels
          .map(c => c.value)
          .filter(c => c?.length && c !== "app");
        file.originalUrl = fileData;
        file.dataUrl = fileData;
        file.title = "";
        file.original_name = file.name;
        file.fit_cover = true;
        if (this.acceptImageMimeType.includes(file.type) && file.type) {
          this.editedItem.images.push({ newFile: file });
          await this.saveImages();
        } else {
          this.createError({
            text:
              "Datei '" +
              file.name +
              "' kann nicht als Bild hochgeladen werden."
          });
        }
      });
      await this.save(false);
      this.refreshKey++;
    },
    async addDropFile(e) {
      if (!Array.isArray(this.editedItem.files)) this.editedItem.files = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const fileData = await this.readFileUrl(file);
        file.originalUrl = fileData;
        file.dataUrl = fileData;
        file.title = file.name;
        file.original_name = file.name;
        file.channels = this.editedItem.channels.filter(c => c !== "app");
        this.editedItem.files.push(file);
      });
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async removeImage(id) {
      // TODO: Remove File from S3
      const index = this.editedItem.images.findIndex(
        f => f.id === id || f._id === id || f.url === id
      );
      if (
        await this.$confirm(
          `Wollen Sie die Datei "${this.editedItem.images[index].original_name}" wirklich löschen?`,
          confirmWarningConfig
        )
      ) {
        // remember files to delete for save-process
        this.removeFileArray.push(
          Object.assign({}, this.editedItem.images[index])
        );
        this.editedItem.images.splice(index, 1);
        this.refreshKey++;
      }
    },
    async removeFile(index) {
      if (
        await this.$confirm(
          `Wollen Sie die Datei "${this.editedItem.files[index].title}" wirklich löschen?`,
          confirmWarningConfig
        )
      ) {
        // remember files to delete for save-process
        this.removeFileArray.push(
          Object.assign({}, this.editedItem.files[index])
        );
        this.editedItem.files.splice(index, 1);
      }
    },
    async saveImages() {
      const files = this.editedItem.images;

      const pictures = [];
      await files.asyncForEach(async file => {
        if (file.imageSizes) {
          file.image_sizes = file.imageSizes;
        }
        const isPdf =
          file.newFile?.type === "application/pdf" ||
          file.url?.split(".")?.pop() === "pdf";
        if (!file.url) {
          //convert base64-data-url to blob
          const res = await fetch(file.newFile.dataUrl);
          const blob = await res.blob();
          blob.filename = file.newFile.name;
          const newFile = await uploadFile(
            blob,
            this.editedItem.id || this.editedItem._id,
            "news",
            this.editedItem.principal_id,
            progressEvent => {
              this.createSuccess(
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % hochgeladen.."
              );
            }
          );
          //add file properties

          file = { ...newFile, ...file.newFile };
          delete file.originalUrl;
          delete file.dataUrl;

          file.locked = newFile.locked;
          file.id = newFile.id;

          if (this.editedItem?._id) {
            this.editedItem.contentTypes = this.editedItem.contentTypes.map(
              contentType => {
                if (!contentType.type.includes("images1")) {
                  return contentType;
                }

                let { selectedImages, ...rest } = contentType;

                if (!selectedImages) selectedImages = [];

                selectedImages.push(file);

                return {
                  selectedImages,
                  ...rest
                };
              }
            );
          }
        } else if (file.url && this.editedItem.isNew) {
          //copy image for cloned news
          await this.copyFile(file);
        }

        pictures.push(file);
      });
      this.editedItem.images = pictures;
      this.editedItem.images.reverse().reverse();
    },
    async saveFiles() {
      const files = this.editedItem.files;

      const fileArray = [];
      await files.asyncForEach(async file => {
        if (!file.url) {
          const isPdfFile = file.type.toLowerCase() === "application/pdf";
          const isAnyImageFile = file.type.toLowerCase().startsWith("image/");
          const newFile = await uploadFile(
            file,
            this.editedItem.id || this.editedItem._id,
            "news",
            this.editedItem.principal_id,
            progressEvent => {
              this.createSuccess(
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % hochgeladen.."
              );
            }
          );

          if (isPdfFile) {
            const generatedPdfPicture = await this.generateImageFromPdf(
              newFile.url,
              newFile.title.replace(".pdf", "")
            );
            newFile.picture = await uploadFile(
              generatedPdfPicture,
              this.editedItem.id || this.editedItem._id,
              "news",
              this.editedItem.principal_id,
              progressEvent => {
                this.$store.dispatch(
                  "createSuccess",
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) + " % Bild aus PDF generiert ..."
                );
              }
            );
          } else if (isAnyImageFile) {
            // set preview for image files
            newFile.picture = { url: newFile.url, ...newFile };
          }

          //add file properties
          file = { ...newFile, ...file, id: newFile.id };

          delete file.originalUrl;
          delete file.dataUrl;

          file.id = newFile.id;
          file.locked = newFile.locked;
        } else if (file.url && this.editedItem.isNew) {
          //copy file for cloned news
          await this.copyFile(file);
        }
        fileArray.push(file);
      });
      this.editedItem.files = fileArray;
      this.editedItem.files.reverse().reverse();
    },
    async removeFiles() {
      await this.removeFileArray.asyncForEach(async (file, index, object) => {
        if (file.url) await destroyFile("news", getMongoFileId(file));
        if (this.editedItem?._id) {
          this.editedItem.contentTypes = this.editedItem.contentTypes.map(
            contentType => {
              if (!contentType.type.includes("images")) {
                return contentType;
              }

              const { selectedImages, ...rest } = contentType;

              const filteredImages = selectedImages.filter(
                sImage => sImage.url !== file.url
              );
              if (filteredImages.length === selectedImages.length) {
                return contentType;
              }

              return {
                filteredImages,
                ...rest
              };
            }
          );
        }
        object.splice(index, 1);
      });
    },
    sortImages(newVal) {
      this.editedItem.images = [...newVal];
    },
    sortFiles(newVal) {
      const order = newVal.map(v => v.url);
      this.editedItem.files = _.sortBy(this.editedItem.files, file => {
        return _.indexOf(order, file.url);
      });
    },
    async refreshRelatedNews() {
      try {
        this.editedItem.related_news = this.editedItem.related_news?.filter(
          Boolean
        );
        await this.$store.dispatch(
          "getRelatedNews",
          this.editedItem.related_news
        );
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    confirmUnrelease(released) {
      // release-value already changed
      // changeback if unrelease not confirmed
      if (!released) {
        this.$confirm(
          "Geprüft wirklich zurücknehmen?",
          confirmWarningConfig
        ).then(yes => {
          if (!yes) {
            this.editedItem.released = true;
          }
        });
      }
    },
    async copyFile(file) {
      const oldFileId = getMongoFileId(file);
      const oldFileDatePath = getPictureUrlDatePath(file.url);
      try {
        const headers = getTokenHeader();
        const res = await axios.post(
          `${env.file_client_url}v1/file/copy`,
          {
            id: oldFileId,
            datePath: oldFileDatePath
          },
          { headers }
        );
        const newFile = {
          id: res.data?.data?._doc?._id,
          url: res.data?.url
        };
        file.url = newFile.url;
        let sizes = file.image_sizes;
        if (sizes) {
          const newPictureDatePath = getPictureUrlDatePath(newFile.url);
          Object.keys(sizes).forEach(key => {
            const find = `${oldFileDatePath ?? "/"}${oldFileId}`;
            const replace = `${newPictureDatePath}${newFile.id}`;
            sizes[key].url = sizes[key].url.replace(find, replace);
          });
        }
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    isAppFeature(feature) {
      return !!feature.appdinx_channel_id;
    },
    isFeatureEditable(feature) {
      if (!feature.editable_by || feature.editable_by === "all") {
        return true;
      }
      if (feature.editable_by === "news_admin") {
        return this.isAdmin || this.newsAdmin;
      }
      if (feature.editable_by === "admin") {
        return this.isAdmin;
      }
      return true;
    },
    isFeatureDisabled(feature) {
      if (this.isLocked(this.editedItem)) {
        return true;
      }
      return !this.isFeatureEditable(feature);
    },
    isRequiredFeatureGroupFulfilled(featureGroup) {
      if (!featureGroup.isRequired) {
        return true;
      }
      return featureGroup.features.some(feature =>
        this.editedItem.feature_ids.includes(feature._id)
      );
    },
    openEmailHtml() {
      window.open(
        this.editedItem.fromExternEmailFile.content.html.url,
        this.editedItem.fromExternEmailFile.content.title,
        "popup=true,width=600,height=800"
      );
    },
    async approveItem(item) {
      const isConfirmed = await this.$confirm(
        "Die Nachricht muss vor der Freigabe gespeichert werden!<br/><br/>Sind Sie sicher, dass Sie diese Nachricht speichern und freigeben möchten?",
        confirmWarningConfig
      );

      if (isConfirmed) {
        let saved;
        try {
          saved = await this.save();
        } catch (e) {
          console.error(e);
        }
        if (!saved) {
          await this.$store.dispatch("createError", {
            text:
              "Freigabe nicht möglich. Die Nachricht konnte nicht gespeichert werden."
          });
          return;
        }

        const headers = getTokenHeader();
        try {
          await axios.get(
            `${env.news_api_client_url}externNews/approve/${item._id}`,
            { headers }
          );
        } catch (err) {
          await this.createError({
            ...err,
            text: "Nachricht konnte nicht freigegeben werden."
          });
          return;
        }
        this.createSuccess("Nachricht erfolgreich freigegeben!");
        this.$emit("afterSave", true);
      }
    },
    async declineItem(item) {
      const isConfirmed = await this.$confirm(
        "Die Nachricht muss vor dem Ablehnen gespeichert werden!<br/><br/>Sind Sie sicher, dass Sie diese Nachricht speichern und ablehnen möchten?",
        confirmWarningConfig
      );

      if (isConfirmed) {
        let saved;
        try {
          saved = await this.save();
        } catch (e) {
          console.error(e);
        }
        if (!saved) {
          await this.$store.dispatch("createError", {
            text:
              "Ablehnen nicht möglich. Die Nachricht konnte nicht gespeichert werden."
          });
          return;
        }

        const headers = getTokenHeader();
        try {
          await axios.get(
            `${env.news_api_client_url}externNews/decline/${item._id}`,
            { headers }
          );
          await this.deleteNews(item);
        } catch (err) {
          await this.createError({
            ...err,
            text: "Nachricht konnte nicht abgelehnt werden."
          });
          return;
        }
        this.createSuccess("Nachricht erfolgreich abgelehnt!");
        this.$emit("afterSave", true);
      }
    },
    async revokeItem(item, isManuallyTriggerd) {
      if (isManuallyTriggerd) {
        const isConfirmed = await this.$confirm(
          `Sind Sie sicher, dass Sie die Freigabe der Nachricht "${item.title}" zurückziehen möchten?`,
          confirmWarningConfig
        );
        if (!isConfirmed) {
          return;
        }
      }

      const headers = getTokenHeader();
      try {
        await axios.get(
          `${env.news_api_client_url}externNews/revoke/${item._id}`,
          { headers }
        );
        if (isManuallyTriggerd) {
          await this.getSharedWithPrincipalStatus();
        }
      } catch (err) {
        await this.createError({
          ...err,
          text: "Nachricht konnte nicht zurückgezogen werden."
        });
        return;
      }
    },
    openShareWithPrincipalsDialog() {
      this.shareWithPrincipals = [];
      this.syncShareWithAllPrincipals();
      this.shareWithPrincipalsSelectionDialog = true;
    },
    closeShareWithPrincipalsDialog() {
      this.shareWithPrincipalsSelectionDialog = false;
    },
    syncShareWithAllPrincipals() {
      const allPrincipals = this.config.shareWithPrincipals ?? [];
      this.shareWithAllPrincipals =
        allPrincipals.length > 0 &&
        this.shareWithPrincipals.length === allPrincipals.length;
    },
    isPrincipalSelected(principalId) {
      return this.shareWithPrincipals.some(
        principal => principal.id === principalId
      );
    },
    toggleSharePrincipal(checked, principal) {
      if (checked) {
        if (!this.isPrincipalSelected(principal.id)) {
          this.shareWithPrincipals.push(principal);
        }
      } else {
        this.shareWithPrincipals = this.shareWithPrincipals.filter(
          sharePrincipal => sharePrincipal.id !== principal.id
        );
      }
      this.syncShareWithAllPrincipals();
    },
    toggleSelectAllSharePrincipals(checked) {
      this.shareWithPrincipals = checked
        ? [...(this.config.shareWithPrincipals ?? [])]
        : [];
      this.syncShareWithAllPrincipals();
    },
    getSharePrincipalStatus(entry) {
      if (entry?.approved && !entry?.declined) {
        return {
          key: "approved",
          label: "Übernommen",
          icon: "mdi-check-circle-outline"
        };
      }
      if (!entry?.approved && entry?.declined) {
        return { key: "declined", label: "Abgelehnt", icon: "mdi-close" };
      }
      return { key: "pending", label: "Ausstehend", icon: "mdi-clock-outline" };
    },
    formatSharedPrincipalDate(date) {
      if (!date) {
        return "-";
      }
      return moment(date).format("DD.MM.YYYY, HH:mm");
    },
    async revokePendingSharedNews() {
      const isConfirmed = await this.$confirm(
        `Sind Sie sicher, dass Sie die Freigabe aller ausstehenden Nachrichten zurückziehen möchten?`,
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }

      const promises = this.sharedWithPrincipalsPendingEntries.map(entry =>
        this.revokeItem(entry)
      );
      await Promise.all(promises);
      await this.getSharedWithPrincipalStatus();
    },
    async shareNewsWithPrincipals() {
      const toPrincipalNames = this.shareWithPrincipals
        .map(p => `"${p.name}"`)
        .join(", ");

      const isConfirmed = await this.$confirm(
        `Die Nachricht muss vor der Freigabe mit anderen Mandanten gespeichert werden!<br/><br/>Sind Sie sicher, dass Sie diese Nachricht speichern und für die ausgewählten Mandanten ${toPrincipalNames} freigeben möchten?`,
        confirmWarningConfig
      );

      if (isConfirmed) {
        let saved;
        try {
          saved = await this.save();
        } catch (e) {
          console.error(e);
        }
        if (!saved) {
          await this.$store.dispatch("createError", {
            text:
              "Freigabe nicht möglich. Die Nachricht konnte nicht gespeichert werden."
          });
          return;
        }

        const headers = getTokenHeader();
        const fromPrincipal = {
          id: this.currentPrincipal?.id,
          name: this.currentPrincipal.name
        };
        const toPrincipalIds = this.shareWithPrincipals
          .map(p => p.id)
          .join(",");
        try {
          await axios.post(
            `${env.news_api_client_url}externNews/principal/${toPrincipalIds}`,
            {
              news: this.editedItem,
              shareWithPrincipals: this.shareWithPrincipals,
              fromPrincipal
            },
            { headers }
          );
        } catch (err) {
          await this.createError({
            ...err,
            text: "Nachricht konnte nicht freigegeben werden."
          });
          return;
        }
        this.shareWithPrincipalsSelectionDialog = false;
        await this.getSharedWithPrincipalStatus();
        this.createSuccess("Nachricht erfolgreich freigegeben!");
      }
    },
    async getSharedWithPrincipalStatus() {
      if (!this.editedItem?._id) {
        return;
      }
      const headers = getTokenHeader();
      const {
        data: status
      } = await axios.get(
        `${env.news_api_client_url}externNews/principal/status/${this.editedItem._id}`,
        { headers }
      );
      this.sharedWithPrincipalsStatus = status;
    },
    async deleteNews(item) {
      const params = {
        principal_id: this.currentPrincipal?.id
      };
      const allFiles = item.files.concat(item.images);
      allFiles.asyncForEach(async file => {
        await destroyFile("news", getMongoFileId(file));
      });
      const headers = getTokenHeader();
      await axios.delete(`${env.news_api_client_url}news/${item._id}`, {
        headers,
        params
      });
    },
    getContentConfig(channelValue) {
      if (channelValue === "_default") {
        const { defaultContentAllowTextFormatting } = this.config;
        if (defaultContentAllowTextFormatting) {
          return { ...this.contentConfigWithFormatting };
        }
        return { ...this.contentConfigWithoutFormatting };
      }

      const channels = [
        ...this.config.standard_channels,
        ...this.config.own_channels
      ];
      const channel = channels.find(channel => channel.value === channelValue);
      const allowContentFormatting = channel?.allowTextFormatting;
      if (allowContentFormatting) {
        return { ...this.contentConfigWithFormatting };
      }
      return { ...this.contentConfigWithoutFormatting };
    },

    async openRewriteDialog(targetKey = "content") {
      this.rewriteTextDialogTargetKey = targetKey;

      // Originaltext aus gewähltem Kanal/Feld
      if (targetKey === "content") {
        const parts = [
          this.editedItem?.content,
          this.editedItem?.content_2,
          this.editedItem?.content_3
        ].filter(Boolean);
        this.rewriteTextDialogOriginal = parts.join(" ");
      } else if (targetKey === "web") {
        const parts = [
          this.editedItem?.alternative_content?.web,
          this.editedItem?.alternative_content_2?.web,
          this.editedItem?.alternative_content_3?.web
        ].filter(Boolean);
        this.rewriteTextDialogOriginal = parts.join(" ");
      }

      this.rewriteTextDialogOpen = true;
    },

    onRewriteTextDialogClose() {
      this.rewriteTextDialogOpen = false;
      this.rewriteTextDialogOriginal = "";
      this.rewriteTextDialogTargetKey = "content";
    },

    onRewriteTextGenerated() {
      // Dialog stays open, user can regenerate or apply
    },

    onRewriteTextApplied(payload) {
      const { text, targetKey } = payload;
      if (!text) return;

      if (targetKey === "content") {
        this.editedItem.content = text;
      } else {
        this.editedItem.alternative_content[targetKey] = text;
      }

      this.onRewriteTextDialogClose();
    },

    onRewriteTextError(errorPayload) {
      const { text } = errorPayload;
      this.$store.commit("SET_SNACKBAR_COLOR", "#c55c52");
      this.$store.commit(
        "SET_SNACKBAR_TEXT",
        text || "Ein Fehler ist aufgetreten."
      );
      this.$store.dispatch("setSnackbar", true);
    }
  }
};
